import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Director } from 'src/app/Models/director';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-diretor',
  templateUrl: './diretor.component.html',
  styleUrls: ['./diretor.component.css'],
  providers: [DatePipe]
})
export class DiretorComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Director;
  isSpinning = false
  logtext: string = "";


  date = new Date();
  date1 = this.datePipe.transform(this.date, 'yyyyMMdd')
  fileDataIMAGE_URL: File = null
  folderName = "DirectorsImages"
  constructor(private api: ApiService, private message: NzNotificationService, private datePipe: DatePipe) {
  }

  ngOnInit() {

  }



  close(): void {
    this.drawerClose();

    this.logtext = 'CLOSED - Directors form';
    this.api.addLog('A', this.logtext, this.api.emailId)
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          console.log(successCode);
        }
        else {
          console.log(successCode);
        }
      });

  }

  save(addNew: boolean): void {

    this.isSpinning = true;

    if (this.data.ID) {

      if (this.fileDataIMAGE_URL) {
        if (this.data.IMAGE_URL == "") {
          this.data.IMAGE_URL = this.genarateKeyIMAGE_URL();
        }
        else {
          var str = this.data.IMAGE_URL.substring(this.data.IMAGE_URL.lastIndexOf('/') + 1).split('.')
          var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
          var url = str[0] + "." + fileExt;
          this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
          //this.data.IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
          this.data.IMAGE_URL = url;

        }
      }
      else {
        this.data.IMAGE_URL = ""
      }

      this.api.updateDirectors(this.data)
        .subscribe(successCode => {
          if (successCode['code'] == "200") {
            this.message.success("Directors information updated Successfully...", "");

            this.logtext = 'Update & Close - Directors form - SUCCESS ' + JSON.stringify(this.data) + " KEYWORD [U - Directors ]";
            this.api.addLog('A', this.logtext, this.api.emailId)
              .subscribe(successCode => {
                if (successCode['code'] == "200") {
                  console.log(successCode);
                }
                else {
                  console.log(successCode);
                }
              });

            if (!addNew)
              this.drawerClose();
            this.isSpinning = false;
          }
          else {

            this.logtext = 'Update & Close - Directors form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [U - Directors ]";
            this.api.addLog('A', this.logtext, this.api.emailId)
              .subscribe(successCode => {
                if (successCode['code'] == "200") {
                  console.log(successCode);
                }
                else {
                  console.log(successCode);
                }
              });

            this.message.error("Failed to update directors information...", "");
            this.isSpinning = false;
          }
        });
    }
    else {
      if (this.fileDataIMAGE_URL) {
        this.data.IMAGE_URL = this.genarateKeyIMAGE_URL()
      }
      else {
        this.data.IMAGE_URL = "";
      }
      this.api.createDirectors(this.data)
        .subscribe(successCode => {
          if (successCode['code'] == "200") {
            console.log(successCode)
            this.message.success("Directors information added successfully...", "");

            if (!addNew) {
              this.drawerClose();

              this.logtext = 'Save & Close - Directors form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Directors ]";
              this.api.addLog('A', this.logtext, this.api.emailId)
                .subscribe(successCode => {
                  if (successCode['code'] == "200") {
                    console.log(successCode);
                  }
                  else {
                    console.log(successCode);
                  }
                });
            }

            else {
              this.data = new Director();
              this.logtext = 'Save & New - Directors form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Directors ]";
              this.api.addLog('A', this.logtext, this.api.emailId)
                .subscribe(successCode => {
                  if (successCode['code'] == "200") {
                    console.log(successCode);
                  }
                  else {
                    console.log(successCode);
                  }
                });

            }
            this.isSpinning = false;
          }
          else {
            this.message.error("Failed to add directors information...", "");
            this.isSpinning = false;
            this.logtext = 'Save & Close - Directors form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Directors ]";
            this.api.addLog('A', this.logtext, this.api.emailId)
              .subscribe(successCode => {
                if (successCode['code'] == "200") {
                  console.log(successCode);
                }
                else {
                  console.log(successCode);
                }
              });

          }
        });
    }
  }

  genarateKeyIMAGE_URL() {
    var number = Math.floor(100000 + Math.random() * 900000)
    var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
    var url = this.date1 + number + "." + fileExt
    this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
    this.data.IMAGE_URL = url;
    return this.data.IMAGE_URL
  }
  onFileSelectedIMAGE_URL(event) {
    this.fileDataIMAGE_URL = <File>event.target.files[0];
    
  }
}